<template>
  <div class="flex flex-col items-center justify-center min-h-[90vh] bg-gray-100 font-sans">
    <div class="bg-white p-8 rounded shadow-md w-full max-w-4xl md:max-w-xl md:w-9/10">
      <h2 v-if="publicVacancy" class="text-3xl font-semibold text-gray-800 mb-6">
        {{ publicVacancy.title || "Job Application" }}
      </h2>
      <div v-else-if="!isLoading && !fetchError" class="text-gray-700 text-center py-4">
        Vacancy not found.
      </div>

      <div v-if="publicVacancy" class="mb-6 border-b pb-4 border-gray-200">
        <p class="text-gray-600 font-semibold">Company: {{ publicVacancy.company }}</p>
      </div>
      <div v-if="isLoading" class="text-gray-600 text-center py-4">
        Loading...
      </div>
      <div v-if="fetchError" class="mt-4 text-red-500 text-center py-4">
        {{ fetchError }}
      </div>
      <div v-if="publicVacancy && !isLoading && !fetchError">
        <div class="mb-4">
          <p class="text-gray-600">
            <span class="font-semibold">Job Type: </span>{{ publicVacancy.jobType }}
          </p>
          <p class="text-gray-600">
            <span class="font-semibold">Workplace Type: </span>{{ publicVacancy.workplaceType }}
          </p>
          <p class="text-gray-600">
            <span class="font-semibold">Location: </span>{{ publicVacancy.employeeLocation }}
          </p>
        </div>
        <div class="mb-6 border-b pb-4 border-gray-200">
          <p class="text-gray-700 whitespace-pre-line">{{ publicVacancy.description }}</p>
        </div>
        <div class="mb-4 flex items-center">
          <input id="read-requirements" type="checkbox"
            class="mr-2 h-4 w-4 border border-gray-300 rounded focus:ring-blue-500 focus:ring-2" v-model="requirementsRead" />
          <label for="read-requirements" class="text-gray-700">
            I have read the job description and meet the requirements.
          </label>
        </div>

        <button :disabled="!requirementsRead" @click="openModal"
          :class="{'bg-blue-500 hover:bg-blue-600 text-white' : requirementsRead,
                   'bg-gray-300 text-gray-500 cursor-not-allowed' : !requirementsRead }"
           class="py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200">
          Apply
        </button>
      </div>
        <appl-modal :is-open="isModalOpen" @close="closeModal" :step="currentStep">
          <template v-if="currentStep === 1">
            <h3 class="text-xl font-semibold text-gray-700 mb-4">
              Personal Information
            </h3>
             <div class="mb-4">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="name">
                  Name:
              </label>
               <input
                id="name"
                v-model="candidate.name"
                 type="text"
               placeholder="Your Name"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
          </div>
          <div class="mb-4">
               <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
                    Email:
                </label>
               <input
                 id="email"
                v-model="candidate.email"
                type="email"
                placeholder="Your Email"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
           <div class="mb-4">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="country-code">
                  Country Code:
              </label>
              <input
                id="country-code"
                v-model="candidate.countryCode"
                type="text"
                placeholder="+1"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
           </div>
           <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="phone-number">
                   Phone Number:
                </label>
              <input
                 id="phone-number"
                v-model="candidate.phoneNumber"
               type="text"
                  placeholder="Your Phone Number"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="linkedin-profile">
                     LinkedIn Profile:
                </label>
               <input
                  id="linkedin-profile"
                   v-model="candidate.linkedin"
                    type="text"
                   placeholder="Your LinkedIn Profile (optional)"
                   class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
           </div>

          <div class="mt-6 flex justify-end">
            <button @click="checkDuplicateAndNextStep"
              :disabled="!candidate.name || !candidate.email"
              :class="{'bg-blue-500 hover:bg-blue-600 text-white' : candidate.name && candidate.email ,
                   'bg-gray-300 text-gray-500 cursor-not-allowed' : !candidate.name || !candidate.email }"
              class="py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200">
                Next
              </button>
           </div>
        </template>
        <template v-else-if="currentStep === 2">
          <h3 class="text-xl font-semibold text-gray-700 mb-4">
            Upload CV
          </h3>
           <div class="mb-4">
               <label class="block text-gray-700 text-sm font-bold mb-2" for="cv-text">
                     Copy & Paste Your CV:
                </label>
             <textarea
               id="cv-text"
                 v-model="candidate.cv"
               placeholder="Paste your CV here..."
                 class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-40"
              />
            </div>
           <div class="mt-6 flex justify-between">
             <button @click="previousStep"
                class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200">
                 Previous
              </button>
                <button @click="nextStep"
                    :disabled="!candidate.cv"
                    :class="{'bg-blue-500 hover:bg-blue-600 text-white' : candidate.cv ,
                   'bg-gray-300 text-gray-500 cursor-not-allowed' : !candidate.cv }"
                     class="py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200">
                  Next
               </button>
           </div>
        </template>
        <template v-else-if="currentStep === 3">
          <h3 class="text-xl font-semibold text-gray-700 mb-4">
            Confirm Your Information
          </h3>
           <div class="mb-4">
                <p class="text-gray-700">
                 <span class="font-semibold">Name:</span> {{ candidate.name }}
               </p>
                <p class="text-gray-700">
                    <span class="font-semibold">Email:</span> {{ candidate.email }}
               </p>
                 <p class="text-gray-700">
                     <span class="font-semibold">Country Code:</span> {{ candidate.countryCode }}
                  </p>
              <p class="text-gray-700">
                 <span class="font-semibold">Phone Number:</span> {{ candidate.phoneNumber }}
                </p>
                <p class="text-gray-700" v-if="candidate.linkedin">
                   <span class="font-semibold">LinkedIn Profile:</span> <a :href="candidate.linkedin" target="_blank" class="text-blue-500 hover:underline">{{ candidate.linkedin }}</a>
               </p>
               <p class="text-gray-700">
                   <span class="font-semibold">CV:</span>
               </p>
               <div class="bg-gray-50 p-3 rounded border border-gray-200 whitespace-pre-wrap overflow-y-auto max-h-[300px] md:max-h-none">
                  {{ candidate.cv }}
                  </div>
            </div>
           <div class="mb-4 flex items-start">
             <input
               id="accept-terms"
               type="checkbox"
               class="mr-2 h-4 w-4 border border-gray-300 rounded focus:ring-blue-500 focus:ring-2 mt-1"
                 v-model="termsAccepted"
             />
              <label for="accept-terms" class="text-gray-700">
                 I accept the
                 <a href="#" @click.prevent="openPrivacyModal" class="text-blue-500 hover:underline">
                    Privacy Policy.
                 </a>
              </label>
            </div>
           <div class="mt-6 flex justify-between">
             <button @click="previousStep" class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200">
                 Previous
             </button>
               <button
                  :disabled="!termsAccepted"
                 @click="submitApplication"
                 :class="{'bg-blue-500 hover:bg-blue-600 text-white' : termsAccepted,
                   'bg-gray-300 text-gray-500 cursor-not-allowed' : !termsAccepted }"
                  class="py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200"
               >
                    Send Application
                </button>
           </div>
        </template>
           <template v-else-if="currentStep === 4">
                 <h3 class="text-xl font-semibold text-gray-700 mb-4 text-center">
                         Thank You!
                    </h3>
                    <p class="text-gray-700 text-center mb-6">Your application has been submitted. The company will review your information and indicate the next steps.</p>
                    <div class="mt-6 flex justify-center">
                      <button @click="goToRoot"  class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200">
                        Exit
                      </button>
                  </div>
              </template>
          <template v-else-if="currentStep === 5">
               <h3 class="text-xl font-semibold text-gray-700 mb-4 text-center">
                        You have already applied for this vacancy.
                    </h3>
                     <div class="mt-6 flex justify-center">
                      <button @click="closeModal"  class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200">
                        OK
                      </button>
                  </div>
        </template>
      </appl-modal>
      <privacy-modal :is-open="isPrivacyModalOpen" @close="closePrivacyModal" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import ApplModal from '@/components/ApplModal.vue';
import PrivacyModal from '@/components/PrivacyModal.vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  components: {
    ApplModal,
    PrivacyModal,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const vacancyId = route.params.id;
    const publicVacancy = ref(null);
    const isLoading = ref(false);
    const fetchError = ref(null);
    const alreadyApplied = ref(false);

    const requirementsRead = ref(false);
    const isModalOpen = ref(false);
    const currentStep = ref(1);
    const candidate = ref({
      name: null,
      email: null,
      countryCode: null,
      phoneNumber: null,
      linkedin: null,
      cv: null,
    });

    const isPrivacyModalOpen = ref(false);
    const termsAccepted = ref(false);

    const fetchData = async () => {
      isLoading.value = true;
      fetchError.value = null;
        alreadyApplied.value = false;
      try {
        const vacanciesResponse = await fetch(`/api/public-vacancy/${vacancyId}`);

        if (!vacanciesResponse.ok) {
          const errorData = await vacanciesResponse.json();
          throw new Error(
            `HTTP error! status: ${vacanciesResponse.status} ${JSON.stringify(
              errorData
            )}`
          );
        }

        const data = await vacanciesResponse.json();

        if (data) {
          publicVacancy.value = data;
        } else {
          fetchError.value = "Vacancy not found";
        }
      } catch (error) {
        console.log(error);
        fetchError.value = error.message;
        publicVacancy.value = null;
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(fetchData);
    const openModal = () => {
      isModalOpen.value = true;
    };

    const closeModal = () => {
      isModalOpen.value = false;
      currentStep.value = 1;
        candidate.value = {
            name: null,
           email: null,
          countryCode: null,
           phoneNumber: null,
           linkedin: null,
          cv: null,
       };
       termsAccepted.value = false;
        alreadyApplied.value = false;
    };

    const nextStep = () => {
      currentStep.value++;
    };
    const previousStep = () => {
      currentStep.value--;
    };

    const openPrivacyModal = () => {
      isPrivacyModalOpen.value = true;
    };
    const closePrivacyModal = () => {
      isPrivacyModalOpen.value = false;
    };
    const checkDuplicateAndNextStep = async () => {
          try{
              isLoading.value = true;
               fetchError.value = null;
            const response = await fetch("/api/check-duplicate-app",{
                 method: "POST",
                 headers: {
                     "Content-Type": "application/json",
                   },
                 body: JSON.stringify({
                     email: candidate.value.email,
                       vacancyId: vacancyId
                 })
              });

             if(!response.ok){
                 const errorData = await response.json();
                  throw new Error(
                       `Failed to check duplicate application: ${response.status} ${JSON.stringify(errorData)}`
                    );

                 }

              const data = await response.json();

             if(data.exists){
                 alreadyApplied.value = true;
                currentStep.value = 5;

               } else {
                nextStep();
            }

         } catch (error){
              fetchError.value = `Failed to check duplicate application: ${error.message}`;
          } finally {
             isLoading.value = false;
         }
    }
     const submitApplication = async () => {
         try {
          isLoading.value = true;
              fetchError.value = null;
        const response = await fetch('/api/submit-application', {
           method: 'POST',
           headers: {
                'Content-Type': 'application/json',
           },
           body: JSON.stringify({
                ...candidate.value,
                 vacancyId: vacancyId,
                 applicationId: uuidv4()
           }),
        });

        if (!response.ok) {
             const errorData = await response.json();
              throw new Error(
                  `Failed to submit application: ${response.status} ${JSON.stringify(
                     errorData
                     )}`
                 );
         }

            currentStep.value = 4;

         }   catch (error) {
            fetchError.value = `Failed to submit application: ${error.message}`;
        } finally {
            isLoading.value = false;
        }
     };
    const goToRoot = () => {
           router.push('/');
      }

    return {
      publicVacancy,
      isLoading,
      fetchError,
      requirementsRead,
      isModalOpen,
      openModal,
      closeModal,
      currentStep,
      nextStep,
      previousStep,
      candidate,
      isPrivacyModalOpen,
      openPrivacyModal,
      closePrivacyModal,
      termsAccepted,
        submitApplication,
        goToRoot,
        alreadyApplied,
        checkDuplicateAndNextStep
    };
  },
};
</script>